import * as React from 'react'
import { Provider } from 'react-redux'
import { Router, Route, Switch, Redirect } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import 'react-datepicker/dist/react-datepicker.css'
import 'react-perfect-scrollbar/dist/css/styles.css'
import fontawesome from '@fortawesome/fontawesome'
import faSolid from '@fortawesome/fontawesome-free-solid'
import faRegular from '@fortawesome/fontawesome-free-regular'
import faBrands from '@fortawesome/fontawesome-free-brands'
import { store, persistor } from './store'
import ProtectedRoute from './common/ProtectedRoute.component'
import AccountRoutes from './routes/account'
import Routes from './routes'
import './styles/App.scss'

import history from './history'

const { PersistGate } = require('redux-persist/lib/integration/react')

// FontAwesome set up
fontawesome.library.add(faSolid, faRegular, faBrands)

class App extends React.Component {
  public render() {
    return (
      <Provider store={store}>
        <PersistGate persistor={persistor} loading="Loading...">
          <Router history={history}>
            <Switch>
              <Route path="/account" component={AccountRoutes} />
              <ProtectedRoute path="/*" component={Routes} />
              <Redirect to="/dashboard" />
            </Switch>
          </Router>

          <ToastContainer />
        </PersistGate>
      </Provider>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.tsx